import _concatInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/concat";
import _indexOfInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/index-of";
import _someInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/some";

/**
Copyright 2016 Split Software

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
**/
import { isString } from '../../utils/lang';
import logFactory from '../../utils/logger';
var log = logFactory('splitio-engine:matcher');
function containsStringMatcherContext(ruleAttr
/*: array */) /*: Function */
{
  return function containsStringMatcher(runtimeAttr
  /*: string */) /*: boolean */
  {
    var _context, _context2;
    var contains = _someInstanceProperty(ruleAttr).call(ruleAttr, function (e) {
      return isString(runtimeAttr) && _indexOfInstanceProperty(runtimeAttr).call(runtimeAttr, e) > -1;
    });
    log.debug(_concatInstanceProperty(_context = _concatInstanceProperty(_context2 = "[containsStringMatcher] ".concat(runtimeAttr, " contains ")).call(_context2, ruleAttr, "? ")).call(_context, contains));
    return contains;
  };
}
export default containsStringMatcherContext;